import { Box, type SxProps, type Theme } from "@mui/material";
import { useGetClipboardScoreProfile } from "@src/appV2/ClipboardScore/api/useGetClipboardScoreProfile";
import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { useLogEffect } from "@src/appV2/lib/analytics/useLogEffect";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";

import { useCanBookLimitedAccessShifts } from "./hooks";
import { LimitedAccessBanner } from "./LimitedAccessBanner";

export interface LimitedAccessBannerContainerProps {
  sx?: SxProps<Theme>;
}

export function LimitedAccessBannerContainer(props: LimitedAccessBannerContainerProps) {
  const { sx } = props;
  const canBookLimitedAccessShifts = useCanBookLimitedAccessShifts();
  const flag = useCbhFlag(CbhFeatureFlag.SHORT_LEAD_SHIFT_ACCESS, {
    defaultValue: { enabled: false },
  });
  const { userId } = useDefinedWorker();
  const { data: scoreProfile } = useGetClipboardScoreProfile(userId, {
    enabled: canBookLimitedAccessShifts,
  });

  useLogEffect(
    APP_V2_USER_EVENTS.LIMITED_ACCESS_BANNER_VIEWED,
    {},
    { enabled: canBookLimitedAccessShifts }
  );

  if (!canBookLimitedAccessShifts || !flag.enabled) {
    return null;
  }

  return (
    <Box sx={sx}>
      <LimitedAccessBanner
        leadTimeThresholdInHrs={flag.leadTimeThresholdInHrs}
        currentScore={scoreProfile?.clipboardScore}
      />
    </Box>
  );
}
